import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectPeriodo, setupBusy} from "@commons/core.slice";
import {useEffect, useState} from "react";
import {UseFormReturn} from "react-hook-form/dist/types";
import {IndiceMese, Periodo} from "@commons/types";

export interface PeriodoForm {
    anno: number,
    mese: number,
}

// Sembra non sia possibile passare un generic a useForm... vedi:
// https://github.com/orgs/react-hook-form/discussions/9016
interface PeriodoFormHandlersOptions {
    autocommit: boolean,
}

const defaultHandlersOptions: PeriodoFormHandlersOptions = {
    autocommit: false,
}

export function useHandlersPeriodoForm(form: UseFormReturn<any>,
                                       onChange?: (anno: number, mese: IndiceMese) => void,
                                       onApply?: (anno: number, mese: IndiceMese) => void,
                                       onReload?: () => void,
                                       options: PeriodoFormHandlersOptions = defaultHandlersOptions
) {
    const dispatch = useAppDispatch();
    const periodoEnvironment: Periodo = useAppSelector(selectPeriodo);
    const [periodoConsolidato, setNextPeriodoConsolidato] = useState<Periodo | null>(periodoEnvironment);

    const {reset, trigger, getValues, setValue, watch, control, register, formState: {errors}} = form;

    // Default iniziale
    /*useEffect(() => {
        reset({...getValues(), anno: periodoEnvironment.anno, mese: periodoEnvironment.mese});
    }, [getValues, reset]); // NON indicare <periodoEnvironment> nelle dipendenze!!!*/

    // Aggiorna anno/mese al variale del periodo predefinito
    // N.B. è fondamentale monitorare direttamente anno e mese perchè periodoEnvironment può variare facilmente (es. al cambio di azienda!)
    useEffect(() => {
        const anno = getValues('anno');
        const mese = getValues('mese');
        if (anno !== periodoEnvironment.anno || mese !== periodoEnvironment.mese) {
            setValue('anno', periodoEnvironment.anno);
            setValue('mese', periodoEnvironment.mese);
            if (onChange) onChange(periodoEnvironment.anno, periodoEnvironment.mese);
        }
    }, [onChange, getValues, setValue, periodoEnvironment.anno, periodoEnvironment.mese]);

    const prevMonth = () => {
        let mese = getValues('mese');
        if (mese > 1) {
            setValue('mese', mese - 1);
        } else {
            setValue('mese', 12);
            setValue('anno', getValues('anno') - 1);
        }
        if (options.autocommit) {
            dispatch(setupBusy(true));
            apply();
        }
    };

    const nextMonth = () => {
        let mese = getValues('mese');
        if (mese < 12) {
            setValue('mese', mese + 1);
        } else {
            setValue('mese', 1);
            setValue('anno', getValues('anno') + 1);
        }
        if (options.autocommit) {
            dispatch(setupBusy(true));
            apply();
        }
    };

    const apply = () => {
        trigger().then((success) => {
            if (success) {
                const {anno, mese} = getValues();
                setNextPeriodoConsolidato({anno, mese});
                if (onApply)
                    onApply(anno, mese);
            }
        });
    }

    const anno: number = watch('anno');
    const mese: IndiceMese = watch('mese');
    /**
     * effect per rilevare la variazione di anno e mese da editing diretto
     */
    useEffect(() => {
        if (periodoConsolidato) {
            //console.log("anno/mese: ", anno, mese)
            if (anno !== periodoConsolidato.anno || mese !== periodoConsolidato.mese) {
                if (onChange) onChange(anno, mese);
            }
        }
    }, [onApply, onChange, periodoConsolidato, anno, mese])

    const reload = () => {
        //reset();
        if (onReload)
            onReload();
        //if (options.autocommit) apply();
    }

    return {prevMonth, nextMonth, reload, apply, control, register, errors};
}
